import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import "./_fonts.scss";
import "./_global.scss";

import { AppNavigation } from "./navigation";

function App() {
  return (
    <Router>
      <AppNavigation />
    </Router>
  );
}

export default App;
